var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#609933"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 40.2502H57.4165M93.7915 76.6252L81.6665 36.2085H69.5415M53.3748 52.3752L37.2082 76.6252H65.4998C65.4998 64.5002 73.5832 52.3752 85.7082 52.3752H81.6665H53.3748ZM53.3748 52.3752L45.2915 40.2502M37.2082 92.7918C41.4958 92.7918 45.6079 91.0886 48.6397 88.0567C51.6716 85.0249 53.3748 80.9128 53.3748 76.6252C53.3748 72.3375 51.6716 68.2254 48.6397 65.1936C45.6079 62.1618 41.4958 60.4585 37.2082 60.4585C32.9205 60.4585 28.8084 62.1618 25.7766 65.1936C22.7448 68.2254 21.0415 72.3375 21.0415 76.6252C21.0415 80.9128 22.7448 85.0249 25.7766 88.0567C28.8084 91.0886 32.9205 92.7918 37.2082 92.7918ZM93.7915 92.7918C98.0792 92.7918 102.191 91.0886 105.223 88.0567C108.255 85.0249 109.958 80.9128 109.958 76.6252C109.958 72.3375 108.255 68.2254 105.223 65.1936C102.191 62.1618 98.0792 60.4585 93.7915 60.4585C89.5038 60.4585 85.3918 62.1618 82.3599 65.1936C79.3281 68.2254 77.6248 72.3375 77.6248 76.6252C77.6248 80.9128 79.3281 85.0249 82.3599 88.0567C85.3918 91.0886 89.5038 92.7918 93.7915 92.7918Z",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction04);
export default __webpack_public_path__ + "static/media/action04.6c129f95ab542726a23f61ed819cf925.svg";
export { ForwardRef as ReactComponent };